import styled, { css } from 'styled-components';
import { Box, Icon } from '@bechtel/gds';

export const RoleItemContainerStyled = styled(Box).attrs({
  pl: { sm: '700' },
  pr: { sm: '400' },
  py: { sm: '400' },
  mt: { sm: '500' },
  alignItems: { sm: 'center' },
})`
  height: 60px;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => theme.radii[200]};
  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 4px 5px 0 rgba(0, 0, 0, 0.14);
`;

interface ActionIconProps {
  disabled: boolean;
}

export const ActionContainerStyled = styled(Box)`
  display: none;
  /* stylelint-disable-next-line */
  ${RoleItemContainerStyled}:hover & {
    display: flex;
  }
`;
export const ActionIconStyled = styled(Icon)`
  margin-left: ${({ theme }) => theme.spacings[600]};

  ${(props: ActionIconProps) =>
    props.disabled
      ? css`
          pointer-events: none;
          opacity: 0.4;
        `
      : css`
          opacity: 1;
          cursor: pointer;
        `}
`;
